"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Text = _interopRequireDefault(require("../../Text"));

require("../styles/_loader.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var LOADER_INITIAL_TIMEOUT = 1500,
    LOADER_TEXT_TIMEOUT = 3e3,
    Loader = function (a) {
  function b() {
    var a;
    return (0, _classCallCheck2["default"])(this, b), a = c.call(this), a.showLoader = function () {
      a._timeout = null, a.setState({
        showLoader: !0
      });
    }, a.showText = function () {
      a._textTimeout = null, a.setState({
        showText: !0
      });
    }, a.state = {
      showLoader: !1
    }, a;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._timeout = setTimeout(this.showLoader, LOADER_INITIAL_TIMEOUT), this._textTimeout = setTimeout(this.showText, LOADER_TEXT_TIMEOUT);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._timeout && clearTimeout(this._timeout), this._textTimeout && clearTimeout(this._textTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.text,
          c = void 0 === b ? "Give us a few moments to fetch this for you." : b,
          d = a.caption,
          e = void 0 === d ? "Need inspiration? Check out out our inspirations page." : d,
          f = a.darkTheme,
          g = this.state,
          h = g.showLoader,
          i = g.showText;
      return h ? _react["default"].createElement("div", {
        className: (0, _classnames["default"])("loader", {
          "loader--dark-theme": f
        })
      }, _react["default"].createElement("div", {
        className: "loader__spinner"
      }, _react["default"].createElement("div", {
        className: "loader__spinner__bounce1"
      }), _react["default"].createElement("div", {
        className: "loader__spinner__bounce2"
      }), _react["default"].createElement("div", {
        className: "loader__spinner__bounce3"
      })), i && _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_Text["default"], {
        className: "loader__title",
        heading3: !0,
        centered: !0,
        noMargin: "top"
      }, c), _react["default"].createElement(_Text["default"], {
        noMargin: !0,
        centered: !0,
        placeholder: !0
      }, e))) : null;
    }
  }]), b;
}(_react.Component);

exports["default"] = Loader;